export default "__VITE_ASSET__CoZDBeza__"